/**
 * An easy-to-remember password, as in the old Pulsepoint: a word that describes, a noun, two
 * digits and a symbol, e.g. "QuietHorse96#". 50 × 50 × 90 × 8 = 1.8 million of them, so
 * it's for a temporary password or a start, not a strong one; it's always at least 10 long, with or without the symbol.
 */
const DESCRIBING = [
  'Quiet', 'Happy', 'Brave', 'Clever', 'Gentle', 'Lucky', 'Sunny', 'Swift', 'Calm', 'Bright',
  'Jolly', 'Mighty', 'Proud', 'Silver', 'Golden', 'Rapid', 'Smart', 'Steady', 'Sharp', 'Bold',
  'Fresh', 'Green', 'Purple', 'Orange', 'Little', 'Giant', 'Fluffy', 'Sleepy', 'Dancing', 'Flying',
  'Running', 'Jumping', 'Singing', 'Shining', 'Rolling', 'Racing', 'Smiling', 'Floating', 'Glowing', 'Hopping',
  'Charging', 'Spinning', 'Climbing', 'Diving', 'Laughing', 'Roaring', 'Sailing', 'Wandering', 'Buzzing', 'Sparkling',
];
const NOUNS = [
  'Horse', 'Tiger', 'Koala', 'Wombat', 'Possum', 'Dingo', 'Falcon', 'Eagle', 'Dolphin', 'Turtle',
  'Rabbit', 'Panda', 'Otter', 'Parrot', 'Penguin', 'Lizard', 'Badger', 'Magpie', 'River', 'Mountain', 
  'Forest', 'Ocean', 'Island', 'Valley', 'Meadow', 'Harbour', 'Desert', 'Canyon', 'Rocket', 'Comet', 
  'Planet', 'Thunder', 'Rainbow', 'Sunset', 'Garden', 'Lantern', 'Anchor', 'Compass', 'Battery', 
  'Engine', 'Spark', 'Magnet', 'Turbine', 'Bicycle', 'Pebble', 'Feather', 'Pepper', 'Banana',
];
const SYMBOLS = '#!@$%&*?';

function pick(n: number): number {
  const a = new Uint32Array(1);
  globalThis.crypto.getRandomValues(a);
  return a[0]! % n;
}

/** Without the symbol (e.g. "QuietHorse96"), for temporary passwords read out or typed from a message. */
export function easyPassword({ symbol = true } = {}): string {
  return `${DESCRIBING[pick(DESCRIBING.length)]}${NOUNS[pick(NOUNS.length)]}${10 + pick(90)}${symbol ? SYMBOLS[pick(SYMBOLS.length)] : ''}`;
}
